import Wrap from '@/components/Wrap.vue'

const routers = [{
    index: 0,
    path: '/',
    name: 'index',
    text: '医步',
    menu: false,
    redirect: '/record',
    component: Wrap
}, {
    index: 10,
    path: '/record',
    name: 'record',
    text: '病历一览',
    menu: true,
    hasChildren: false,
    redirect: '/record/list',
    component: Wrap,
    children: [{
        path: '/record/list',
        name: 'record_list',
        text: '列表',
        menu: false,
        component: resolve => require(['../views/record/List'], resolve)
    }, {
        path: '/record/add',
        name: 'record_add',
        text: '创建病历',
        menu: false,
        component: resolve => require(['../views/record/Add'], resolve)
    }, {
        path: '/record/show/:id',
        name: 'record_show',
        text: '病历详情',
        menu: false,
        component: resolve => require(['../views/record/Detail'], resolve)
    }]
}, /*{
    index: 20,
    path: '/followup',
    name: 'followup',
    text: '随访管理',
    menu: true,
    permission: null,
    component: resolve => require(['../views/followup/list'], resolve)
}*/
{
    index: 20,
    path: '/followup',
    name: 'followup',
    text: '随访管理',
    menu: true,
    hasChildren: false,
    redirect: '/followup/list',
    component: Wrap,
    children: [{
        path: '/followup/list',
        name: 'followup_list',
        text: '随访列表',
        menu: false,
        component: resolve => require(['../views/followup/list'], resolve)
    }, {
        path: '/followup/add/:hid',
        name: 'followup_add',
        text: '建立随访',
        menu: false,
        component: resolve => require(['../views/followup/add'], resolve)
    }, {
        path: '/followup/count/:hid',
        name: 'followup_count',
        text: '随访率',
        menu: false,
        component: resolve => require(['../views/followup/count'], resolve)
    }]
}, {
    index: 30,
    path: '/databank',
    name: 'databank',
    text: '宣传病例',
    menu: true,
    hasChildren: false,
    redirect: '/databank/normcase',
    component: Wrap,
    children: [{
        path: '/databank/normcase',
        name: 'databank_normcase',
        text: '宣传病例列表',
        menu: false,
        component: resolve => require(['../views/databank/normcase'], resolve)
    }, {
        path: '/databank/normcaseadd/:id',
        name: 'databank_normcaseadd',
        text: '编辑宣传病例',
        menu: false,
        component: resolve => require(['../views/databank/normcase-add'], resolve)
    }, {
        path: '/databank/normcaseshow/:id',
        name: 'databank_normcaseshow',
        text: '宣传病例展示',
        menu: false,
        component: resolve => require(['../views/databank/normcase-show'], resolve)
    }, {
        path: '/databank/normcasedoctor/:id',
        name: 'databank_normcasedoctor',
        text: '宣传病例医生',
        menu: false,
        component: resolve => require(['../views/databank/normcase-doctor'], resolve)
    }]
    /*}, {
      index: 40,
      path: '/demo',
      name: 'demo',
      text: '测试组件',
      menu: true,
      hasChildren: false,
      component: resolve => require(['../views/Demo'], resolve)*/
}]

export default routers
